(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["profile-web-ui-polyfills"] = factory();
	else
		root["profile-web-ui-polyfills"] = factory();
})(self, () => {
return 